module.exports = __webpack_public_path__ + "static/img/charm_level_95.223d2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_95.png
// module id = htvZ
// module chunks = 0